export const isOnMobile = ():boolean => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const getCardWidth = ():string => {
    return isOnMobile() ? "100px" : "140px"
}